import * as THREE from 'three'
import ReactDOM from 'react-dom'
import React, { Suspense, useRef, useMemo, useState, useEffect } from 'react'
import { Canvas, useLoader, useFrame } from 'react-three-fiber'
import uniform from './uniform'
import './styles.css'

uniform.init(THREE)
const makeUrl = file => `https://raw.githubusercontent.com/flowers1225/threejs-earth/master/src/img/${file}.jpg`

const isMobile = window.innerWidth <= 600

function Earth() {
  const ref = useRef()
  const [texture, bump, moon] = useLoader(THREE.TextureLoader, [
    makeUrl('earth4'),
    makeUrl('earth_bump'),
    'http://jaanga.github.io/moon/heightmaps/WAC_GLD100_E000N1800_004P-1024x512.png'
  ])
  useFrame(({ clock }) => (ref.current.rotation.x = ref.current.rotation.y = ref.current.rotation.z = Math.cos(clock.getElapsedTime() / 8) * Math.PI))
  return (
    <group ref={ref} scale={isMobile ? [0.64, 0.64, 0.64] : [0.8, 0.8, 0.8]} position={isMobile ? [0, -0.5, 0] : [0, 0, 0]}>
      <Stars />
      <rectAreaLight intensity={1} position={[10, 10, 10]} width={10} height={1000} onUpdate={self => self.lookAt(new THREE.Vector3(0, 0, 0))} />
      <rectAreaLight intensity={1} position={[-10, -10, -10]} width={1000} height={10} onUpdate={self => self.lookAt(new THREE.Vector3(0, 0, 0))} />
      <mesh>
        <sphereBufferGeometry attach="geometry" args={[2, 64, 64]} />
        <meshStandardMaterial attach="material" map={texture} bumpMap={bump} bumpScale={0.05} />
      </mesh>
      <mesh position={[5, 0, -10]}>
        <sphereBufferGeometry attach="geometry" args={[0.5, 64, 64]} />
        <meshStandardMaterial attach="material" color="gray" map={moon} />
      </mesh>
    </group>
  )
}

function Overlay() {
  return (

<div class="logo">
  <a href="/">Welcome to the world of <br />Kahn
  </a>
</div>
  )
}


function Stars({ count = 5000 }) {
  const positions = useMemo(() => {
    let positions = []
    for (let i = 0; i < count; i++) {
      positions.push(Math.random() * 10 * (Math.round(Math.random()) ? -40 : 40))
      positions.push(Math.random() * 10 * (Math.round(Math.random()) ? -40 : 40))
      positions.push(Math.random() * 10 * (Math.round(Math.random()) ? -40 : 40))
    }
    return new Float32Array(positions)
  }, [count])
  return (
    <points>
      <bufferGeometry attach="geometry">
        <bufferAttribute attachObject={['attributes', 'position']} count={positions.length / 3} array={positions} itemSize={3} />
      </bufferGeometry>
      <pointsMaterial attach="material" size={1} sizeAttenuation color="white" transparent opacity={0.8} />
    </points>
  )
}


function MuteButton({ audioRef, muted, setMuted }) {
  const toggle = () => {
    const audio = audioRef.current
    if (!audio) return
    if (muted) {
      audio.currentTime = 0
      audio.play().catch(() => {})
    } else {
      audio.pause()
    }
    setMuted(!muted)
  }

  return (
  <>
    <button className="mute-btn" onClick={toggle} aria-label={muted ? 'Unmute' : 'Mute'}>
      {muted ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </svg>
      ) : (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
        </svg>
      )}
    </button>
    <div className="now-playing">
      <div className="now-playing-inner">
        <span role="img" aria-label="Now playing"><a className="spotify-link" href="https://open.spotify.com/artist/7ygvpIVVRhoysWTUtjLUnm" target="_blank" rel="noopener noreferrer">Just Three Bros</a>: <a className="spotify-link" href="https://open.spotify.com/track/2CnXc2ZjbhbX4hTlmn6Lfb?si=5967bd1a4ec44dda" target="_blank" rel="noopener noreferrer">Rawhide <svg className="spotify-icon" viewBox="0 0 24 24" width="12" height="12" fill="#1DB954"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg></a> (feat. Alex Kane), 2025, BroSquad Records ©️&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;<a className="spotify-link" href="https://open.spotify.com/artist/7ygvpIVVRhoysWTUtjLUnm" target="_blank" rel="noopener noreferrer">Just Three Bros</a>: <a className="spotify-link" href="https://open.spotify.com/track/2CnXc2ZjbhbX4hTlmn6Lfb?si=5967bd1a4ec44dda" target="_blank" rel="noopener noreferrer">Rawhide <svg className="spotify-icon" viewBox="0 0 24 24" width="12" height="12" fill="#1DB954"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg></a> (feat. Alex Kane), 2025, BroSquad Records ©️&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;</span>
      </div>
    </div>
  </>
  )
}

function App() {
  const videoRef = useRef()
  const audioRef = useRef(null)
  const [muted, setMuted] = useState(true)

  useEffect(() => {
    const audio = new Audio('/rawhide.mp3')
    audio.loop = true
    audioRef.current = audio
    return () => { audio.pause(); audio.src = '' }
  }, [])

  useEffect(() => {
    const v = videoRef.current
    if (!v) return
    v.setAttribute('muted', '')
    v.setAttribute('playsinline', '')
    v.setAttribute('webkit-playsinline', 'true')
    const tryPlay = () => {
      const p = v.play()
      if (p) p.catch(() => {
        const resume = () => {
          v.play().catch(() => {})
          const a = audioRef.current
          if (a) { a.currentTime = 0; a.play().catch(() => {}) }
          setMuted(false)
          document.removeEventListener('touchstart', resume)
          document.removeEventListener('click', resume)
        }
        document.addEventListener('touchstart', resume, { once: true })
        document.addEventListener('click', resume, { once: true })
      })
    }
    v.addEventListener('loadeddata', tryPlay)
    tryPlay()
    return () => v.removeEventListener('loadeddata', tryPlay)
  }, [])
  return (

<div style={{ position: 'relative', width: '100%', height: '100%' }}>
<video ref={videoRef} className="bg-video" autoPlay muted loop playsInline preload="auto">
  <source src="/kane.mp4" type="video/mp4" />
  <source src="/kane.webm" type="video/webm" />
</video>
<div className="bg-overlay">
<MuteButton audioRef={audioRef} muted={muted} setMuted={setMuted} />
<Overlay />
<Canvas
    camera={{ position: [0, 0, 10], fov: 40 }}
    onCreated={({ gl }) => {
      gl.gammaInput = true
      gl.toneMapping = THREE.ACESFilmicToneMapping
    }}>
    <pointLight intensity={0.1} position={[10, 10, 10]} />
    <rectAreaLight intensity={3} position={[0, 10, -10]} width={30} height={30} onUpdate={self => self.lookAt(new THREE.Vector3(0, 0, 0))} />
    <Suspense fallback={null}>
      <Earth />
    </Suspense>
  </Canvas>
</div>
</div>
  )
}
ReactDOM.render(
  <App />
  ,
  document.getElementById('root')
)
